/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { SaasAxios } from '@quick/saas-axios'
import { refreshToken } from './middleware/token'
import ksoAccount from '@plus/axios-interceptor/dist/request/kso-account'

let config = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=utf-8',
  },
  withCredentials: true,
}
const instance = new SaasAxios(config)
// 刷新token
instance.createCustomResponseInterceptors(response => response, refreshToken)
// @ts-ignore
instance.service.interceptors.request.use(ksoAccount())

instance.service.interceptors.response.use(
  function (response) {
    // Do something with response data
    const data = response.data
    response.data = data
    return response
  },
  function (error) {
    const res = error.response || {}
    const data = res.data || {}

    throw data
  }
)
const http = {
  get: function <T>(domain, url, params = {}, config = {}) {
    return instance.get<T>(domain, url, { params, ...config })
  },
  post: function <T>(domain, url, params = {}, config = {}) {
    return instance.post<T>(domain, url, params, config)
  },
  put: function <T>(domain, url, params = {}, config = {}) {
    return instance.put<T>(domain, url, params, config)
  },
  originGet: function <T>(url, params = {}, config = {}) {
    return instance.service.get<T>(url, { params, ...config })
  },
  originPost: function <T>(url, params = {}, config = {}) {
    return instance.service.post<T>(url, params, config)
  },
  originPut: function <T>(url, params = {}, config = {}) {
    return instance.service.put<T>(url, params, config)
  },
}

export default http
